import {
  invert_nav,
  normal_nav_wrapper
} from 'Styles/modules/m-header.module.scss';

import { ALLOW_LIST_TYPE } from 'Lib/constants/path';
import Error from 'next/error';
import Head from 'next/head';
import Layout from 'Components/Layout';
import MobileNav from 'Components/Headers/MobileNav';
import NavBackButton from 'Components/Headers/NavBackButton';
import ProductList from 'Components/Collection/ProductList';
import classNames from 'classnames';
import client from 'Lib/ApolloClient';
import { productsQuery } from 'Lib/query-param';

export default function Collection(props) {
  const { products, pageMeta, pageInfo, loading, errorCode, slug } = props;

  if (errorCode) {
    return <Error errorCode={404} />;
  }

  return (
    <Layout className="product-list">
      <Head>
        <title>{pageMeta?.name}</title>
        <meta
          property="og:type"
          content="product"
          key="ogtype"
        />
        <meta
          property="og:title"
          content={`Bộ sưu tập ${pageMeta?.name}`}
          key="ogtitle"
        />
        <meta
          property="og:description"
          content={`Các sản phẩm ${pageMeta.name} đang được quan tâm nhiều nhất tại Xixon perfume`}
          key="ogdescription"
        />
      </Head>
      <div className={classNames(normal_nav_wrapper, 'border-b')}>
        <NavBackButton />
        <h1>{pageMeta?.name}</h1>
        <MobileNav className={invert_nav} />
      </div>
      <ProductList
        products={products}
        pageMeta={pageMeta}
        pageInfo={pageInfo}
      />
    </Layout>
  );
}

export async function getServerSideProps(context) {
  const { query: queryParams } = context;
  let errorCode = null;

  if (!queryParams?.list || ALLOW_LIST_TYPE.indexOf(queryParams.list) < 0) {
    errorCode = 404;
  }

  const { data, loading, error } = await client.query(
    productsQuery(queryParams)
  );

  if (!data.products) {
    return {
      redirect: {
        permanent: false,
        destination: "/"
      }
    }
  }

  return {
    props: {
      products: data.products?.edges || null,
      pageMeta: {
        name:
          data?.productCategory?.name ||
          data?.productCollection?.name ||
          data?.productBrand?.name ||
          data?.productPerfumeNote?.name ||
          data?.productTag?.name ||
          '',
        description:
          data?.productCategory?.description ||
          data?.productCollection?.description ||
          data?.productBrand?.description ||
          data?.productPerfumeNote?.description ||
          data?.productTag?.description ||
          ''
      },
      pageInfo: data.products?.pageInfo || null,
      loading,
      slug: data?.slug || null,
      errorCode
    }
  };
}
